import styled from 'styled-components';

const FooterWrapper = styled.footer`
  height: ${({ theme }) => theme.spacing(8)};
`;

// eslint-disable-next-line import/prefer-default-export
export { FooterWrapper };
